<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-8">
                <h4 class="m-b-0" v-if="total>0">Linked Accounts</h4>
                <p class="text-muted m-t-0" v-if="total>0">Click view to see information such as transaction details and more.</p>
            </div>
            <div class="col-4">

            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body border-top" v-bind:key="index" v-for="(account, index) in accounts">
                        <div class="row m-b-0">
                            <div class="col-lg-5 col-md-6">
                                <div class="d-flex align-items-center">
                                    <div>
                                        <span>Account</span>
                                        <h4 class="font-medium m-b-0">XXXXXXXXX......{{account.mask}}</h4>
                                        <p class="text-muted">{{account.official_name}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-2 col-md-6">
                                <div class="d-flex align-items-center">
                                    <div>
                                        <span>Type</span>
                                        <address>
                                            <strong>{{account.name}}</strong>
                                            <br> {{account.type}}
                                        </address>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-2 col-md-6">
                                <div class="d-flex align-items-center">
                                    <div>
                                        <span>Current Balance</span>
                                        <h4 class="font-medium m-b-0" style="color: #1976D2" v-if="account.current_balance">{{account.current_balance}} {{account.iso_currency_code}}</h4>
                                        <h4 class="font-medium m-b-0" style="color: #1976D2" v-if="!account.current_balance">0.00</h4>
                                        <span>Available Balance</span>
                                        <h4 class="font-medium m-b-0" style="color: #1976D2" v-if="account.available_balance">{{account.available_balance}} {{account.iso_currency_code}}</h4>
                                        <h4 class="font-medium m-b-0" style="color: #1976D2" v-if="!account.available_balance">0.00</h4>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-6">
                                <div class="d-flex ml-auto">
                                    <div>
                                        <span>Actions</span>
                                        <br>
                                        <div aria-label="Button group with nested dropdown" class="btn-group" role="group">
                                            <button @click="toTransactions(account.account_id)" class="btn btn-secondary" type="button">View Transactions</button>
                                            <div class="btn-group" role="group">
                                                <button aria-expanded="false" aria-haspopup="true" class="btn btn-secondary dropdown-toggle" data-toggle="dropdown" id="btnGroupDrop1" type="button">
                                                    <i class="fas fa-cog"></i>
                                                </button>

                                                <div aria-labelledby="btnGroupDrop1" class="dropdown-menu">
                                                    <a @click="removeAccount(account.account_id)" class="dropdown-item" data-target="#confirmModal" data-toggle="modal" href="javascript:void(0)">Remove
                                                        Account</a>
                                                    <a class="dropdown-item" href="javascript:void(0)">Deposit</a>
                                                    <a class="dropdown-item" href="javascript:void(0)">Withdraw</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-if="total>0">
            <div class="col-12">
                <paginate
                        :click-handler="pageHandler"
                        :container-class="'pagination float-right'"
                        :margin-pages="2"
                        :next-class="'page-link'"
                        :next-text="'Next'"
                        :page-class="'page-link'"
                        :page-count=pageCount
                        :page-range="3"
                        :prev-class="'page-link'"
                        :prev-text="'Prev'">
                </paginate>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapGetters} from "vuex";
    import Paginate from 'vuejs-paginate';

    export default {
        name: "Accounts",
        data() {
            return {
                accounts: [],
                pageCount: 1,
                total: 0,
            }
        },
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        components: {Paginate},
        beforeMount() {
            this.init();
        },
        methods: {
            async init() {
                await this.getAccounts(1);
            },
            async getAccounts(page) {
                try {
                    $(".preloader").fadeIn();
                    let reply     = await this.$http.get(`/banking/${this.currentOrg.id}/accounts`, {
                        params: {
                            page: page,
                            perPage: 10
                        }
                    });
                    $(".preloader").fadeOut();
                    this.total    = reply.data.total;
                    this.accounts = reply.data.accounts;
                } catch(e) {
                    $(".preloader").fadeOut();
                    console.log(e);
                }
            },
            pageHandler(pageNum) {
                this.getMembers(pageNum);
            },
            setPageCount() {
                this.pageCount = this.total <= 10 ? 1 : Math.ceil(this.total / 10);
            },
            toTransactions(account_id) {
                this.$router.push({name: 'transactions', params: {accountid: account_id}});
            },
            async removeAccount(account_id) {
                try {
                    await this.$http.post(`/banking/removeaccount`, {
                        account_id: account_id
                    });
                    this.$toastr('success', 'Bank Account Successfully Deleted', 'Success');
                    this.getAccounts(1);
                } catch(e) {
                    console.log(e);
                }
            }

        }
    }
</script>

<style scoped>
</style>
